






































































import {
    Component,
    Prop,
    Vue,
    Inject,
    Provide,
    Watch
} from "vue-property-decorator";
@Component({
})
export default class HomeNews extends Vue{
    @Prop(String) readonly caption!:string;
    @Prop(Array) readonly data:any;
    
    do_news_click(item){
        window.open(item.url)
    }
}
